export default "__VITE_ASSET__LKey_1gc__"